
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.745 2.585C.35 1.405 1.527.294 2.692.786c1.791.757 4.657 1.996 6.722 3.02 2.348 1.163 5.499 2.96 7.196 3.944.965.56.965 1.94 0 2.5-1.697.984-4.848 2.78-7.196 3.944-2.065 1.024-4.93 2.262-6.722 3.02-1.165.492-2.342-.619-1.947-1.8L2.89 9 .745 2.585zm3.26 7.04L1.937 15.81a.2.2 0 00.266.252c1.79-.757 4.624-1.983 6.653-2.988 2.306-1.143 5.425-2.921 7.123-3.906a.193.193 0 000-.337C14.28 7.847 11.16 6.07 8.855 4.926 6.826 3.92 3.992 2.695 2.202 1.938a.2.2 0 00-.266.251l2.07 6.185H7.46a.627.627 0 110 1.251H4.006z"}})])
          )
        }
      }
    